import { render, staticRenderFns } from "./EmpresaOperadora.vue?vue&type=template&id=20aa5420&"
import script from "./EmpresaOperadora.vue?vue&type=script&lang=js&"
export * from "./EmpresaOperadora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports